
export function ready(fn: () => any) {
  if (document.readyState !== 'loading') {
    fn();
    return;
  }
  document.addEventListener('DOMContentLoaded', fn);
}

let domLoaders: Array<(el: Element|Document) => any> = [];

export function onNewDOM(fn: (el: Element|Document) => any) {
    domLoaders.push(fn);

    if (document.readyState !== 'loading') {
        fn(document);
        return;
    } 
}

ready(() => {

    domLoaders.forEach((cb) => {
        cb(document)
    })

    document.addEventListener("dom.load", (e) => {
        let element = e.target as Element;

        domLoaders.forEach((cb) => {
            cb(element)
        })
    })
});